import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import userManager from './auth.ts';

export default function Callback() {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    userManager.signinRedirectCallback()
      .then(async (user) => {
        await userManager.storeUser(user);
        navigate('/', { replace: true });
      })
      .catch(err => {
        console.error('Auth callback error:', err);
        navigate('/unauthorised', { replace: true });
      });
  }, []);

  return <p>Signing in...</p>;
}
